module.exports = __webpack_public_path__ + "static/media/DyAppLoginLogo.f52abb64.png";